// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-MenuList-module--cls1--3SmfF","cls2":"styles-MenuList-module--cls2--16CZR styles-MenuList-module--cls1--3SmfF"};